module.exports = __webpack_public_path__ + "img/cube4.eac6d1a9.png";